import { Component, OnInit } from '@angular/core';
import { NavigateService } from '../../service/navigate.service';
import { EventsService } from '../../service/events.service';
import { DomSanitizer } from '@angular/platform-browser';

declare var $: any;
@Component({
  selector: 'app-events-cywvf',
  templateUrl: './events-cywvf.component.html',
  styleUrls: ['./events-cywvf.component.styl', '../events-index/events-index.component.styl', '../../share/breadcrumb/breadcrumb.component.styl']
})
export class EventsCywvfComponent implements OnInit {
  showLists: any;
  isPlay: boolean;
  isItemPlay: boolean;
  itemShow: boolean;
  videoList: any;
  videoUrl: any;
  constructor(private navigateService: NavigateService,
    private eventService: EventsService, private sanitizer: DomSanitizer) {
  }

  getSafeVideoUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
  }

  playitemVideo() {
    if (!this.isItemPlay) {
      $('#itemvideo')[0].play()
      this.isItemPlay = true
    } else {
      $('#itemvideo')[0].pause()
      this.isItemPlay = false
    }
  }

  ngOnInit() {
    //默认查询全国第一页数据
    this.showLists = [
      {
        index: 1,
        engName: 'Theme',
        chiName: '主题',
        enCon: 'Directly focus on well-being, showcasing personal or observed experiences.',
        chiCon: '直接关注青少年身心健康，展示个人或观察到的成长体验。'
      },
      {
        index: 2,
        engName: 'Theme',
        chiName: '主题',
        enCon: "Stories must be genuine and reflect the students' or their community's real-life scenarios.",
        chiCon: '故事必须真实，反映学生或其社区的真实成长场景。'
      },
      {
        index: 3,
        engName: 'Originality',
        chiName: '原创性',
        enCon: 'All work submitted should be original, with no plagiarism. Submissions will be checked for original content.',
        chiCon: '提交的所有作品必须原创，不得抄袭。提交的作品将进行原创内容检查。本活动不接受人工智能生成的视频。'
      },
      {
        index: 4,
        engName: 'Creativity',
        chiName: '创造性',
        enCon: 'Judges will assess the inventiveness in conveying the message of well-being.',
        chiCon: '评委将评估传达身心健康信息的创造力。'
      },
      {
        index: 5,
        engName: 'Impact',
        chiName: '影响力',
        enCon: 'The video should aim to resonate with viewers, inspiring reflection on well-being.',
        chiCon: '视频应旨在引起观众的共鸣，激发对身心健康的反思。'
      },
    ]
    this.videoList = [
      {
        index: 0,
        name: '我和他们（I and They）',
        groupName: 'Jouen Zhang',
        allName: '张家胤Jouen',
        school: '华南师范大学附属中学国际部',
        isPlay: false,
        videoUrl: '../../../assets/video/video_01.mp4',
        background: '../../../assets/img/vedio_01@3x.png'
      },
      {
        index: 1,
        name: 'Peer pressure',
        groupName: '六个核桃',
        allName: '李姝萱，韩乐杨，朱静漪，张绎之，常宁皓，吕梓萱',
        school: '北京师范大学附属中学',
        isPlay: false,
        videoUrl: '../../../assets/video/video_02.mp4',
        background: '../../../assets/img/vedio_02@3x.png'
      },
      {
        index: 2,
        name: '当我将自闭症少年座位我的正半轴',
        groupName: '郭金颖',
        allName: '郭金颖',
        school: '广州外国语学校',
        isPlay: false,
        videoUrl: '../../../assets/video/video_03.mp4',
        background: '../../../assets/img/vedio_03@3x.png'
      },
      {
        index: 3,
        name: '7325',
        groupName: 'Laugh out Loud',
        allName: '成子昱Fish Cheng 刘逸帆Peter Liu 任臻宽Edward Ren 王海洋Mark Wang 王其其格Cicily Wang 张柏伟David Zhang',
        school: '上海浦东万科学校Vanke School Pudong',
        isPlay: false,
        videoUrl: '../../../assets/video/video_04.mp4',
        background: '../../../assets/img/vedio_04@3x.png'
      },
      {
        index: 4,
        name: '星',
        groupName: '弗洛伊德的春天',
        allName: '陈天歆，钟达思，赵浩然，陈可馨，叶恺方',
        school: '华南师范大学附属中学国际部',
        isPlay: false,
        videoUrl: '../../../assets/video/video_05.mp4',
        background: '../../../assets/img/vedio_05@3x.png'
      },
      {
        index: 5,
        name: 'Vaporize',
        groupName: 'Untitled',
        allName: 'Annie 任梦元，Jenny 李佳妮',
        school: 'Keystone Academy 北京市鼎石学校',
        isPlay: false,
        videoUrl: '../../../assets/video/video_06.mp4',
        background: '../../../assets/img/vedio_06@3x.png'
      },
      {
        index: 6,
        name: '"友“一丝光',
        groupName: '斗转星移',
        allName: '徐寄筝 张赫铭 张馨尹 杜婧旖',
        school: '重庆巴蜀常春藤学校',
        isPlay: false,
        videoUrl: '../../../assets/video/video_07.mp4',
        background: '../../../assets/img/vedio_07@3x.png'
      },
      {
        index: 7,
        name: 'Warm Fire',
        groupName: 'G for girls',
        allName: '李瑞涵 谢林杉 黄扬子 杨雪莜 姚思含 刘悦彤',
        school: '华南师范大学附属中学国际部',
        isPlay: false,
        videoUrl: '../../../assets/video/video_08.mp4',
        background: '../../../assets/img/vedio_08@3x.png'
      },
      {
        index: 8,
        name: 'The Correct Answer',
        groupName: 'Mefloar',
        allName: 'Xin Ai, Lurun Qin',
        school: 'Shanghai New Epoch Bilingual School',
        isPlay: false,
        videoUrl: '../../../assets/video/video_09.mp4',
        background: '../../../assets/img/vedio_09@3x.png'
      }
    ]
    this.isPlay = false
    this.isItemPlay = false
    this.itemShow = false
    setTimeout(function () {
      $('.wrap-box').css("min-height", $(window).height());
    }, 0);
  }

  setFooter(n) {
    if (($('body').height() + 234 * n) < $(window).height()) {
      $('footer').css({ "position": "fixed", "bottom": "0" });
    } else {
      $('footer').css({ "position": "relative", "bottom": "auto" });
    }

    window.onload = function () {
      if ($('body').height() < $(window).height()) {
        $('footer').css({ "position": "fixed", "bottom": "0" });
      } else {
        $('footer').css({ "position": "relative", "bottom": "auto" });
      }
    }

    window.onresize = function () {
      if ($('body').height() < $(window).height()) {
        $('footer').css({ "position": "fixed", "bottom": "0" });
      } else {
        $('footer').css({ "position": "relative", "bottom": "auto" });
      }
    }
  }

  playVideo() {
    if (!this.isPlay) {
      $('#homepagevideo')[0].play()
      this.isPlay = true
    } else {
      $('#homepagevideo')[0].pause()
      this.isPlay = false
    }
  }

  closeVideo() {
    this.itemShow = false
    this.isItemPlay = false
  }

  playSmallVideo(index) {
    this.videoUrl = this.videoList[index].videoUrl
    this.itemShow = true
    setTimeout(() => {
      this.playitemVideo()
    }, 0)
  }

  format(t) {
    let unixTimestamp = new Date(t);
    let mon = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    let commonTime = mon[unixTimestamp.getMonth()] + ' ' + unixTimestamp.getDate() + ', ' + unixTimestamp.getFullYear();
    return commonTime;
  }

  go(url) {
    this.navigateService.push();
    this.navigateService.pushToRoute(url);
  }

  onShowPage() { }

}



// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/events/events-cywvf/events-cywvf.component.ts